/** The width a step is read at when it asks for nothing wider. */
export const DEFAULT_SUB_STEP_MAX_WIDTH = '552px';

/**
 * A step reads best in a single narrow column, so anything wider has to earn
 * it: a step holding two models side by side needs room for two of those
 * columns and everything that sits beside them.
 */
const SUB_STEP_MAX_WIDTHS: Record<string, string> = {
  WITHDRAW_FORM: '1000px',
  CALCULATOR: '1000px',
  // Allocation bands are a table of four columns per row, which the width a
  // form is read at cannot hold without cutting the names short.
  EDIT_HOUSEHOLD_MODEL_PORTFOLIO_IPS: '800px',
  REVIEW_IPS_SUMMARY: '1600px',
  // Holdings read against the ones they replace: two columns of weights beside
  // a security name long enough not to be cut short.
  REVIEW_ALLOCATIONS: '900px',
  // Editing holdings puts a chart beside a table of five columns, which only
  // has the room to sit that way well past a form's width. The name the
  // create-model-portfolio workflow sends is left at the width that flow has
  // always read at.
  ADD_MODEL_PORTFOLIO_SECURITY_ALLOCATIONS: '1200px',
  // Initialize edits the same chart and the same five-column table, so it
  // needs the room that editing holdings does.
  INITIALIZE_HOUSEHOLD_MODEL_PORTFOLIO: '1200px',
};

export const subStepMaxWidth = (stepType: string): string =>
  SUB_STEP_MAX_WIDTHS[stepType] ?? DEFAULT_SUB_STEP_MAX_WIDTH;
